import { Routes } from '@angular/router';

export const ROUTES: Routes = [

];
